export default "__VITE_ASSET__BQNiDKI___"